// extracted by mini-css-extract-plugin
export default {"mainHolder":"SchoolStudents_mainHolder__FbFh1","rowHolder":"SchoolStudents_rowHolder__NeGUS","paramHolder":"SchoolStudents_paramHolder__U5QGA"};